import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Assets/css/global.css';
import './Assets/css/spacing.css';
import './Assets/css/font.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './Store/Store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
window.onbeforeunload = function() {
  localStorage.clear();
}
root.render(
  <Provider store={store}>
    <Router> <App /></Router>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
